import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AttachmentMediaTypeEnum } from 'src/app/shared/models/misc.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { WhatsappTemplatesService } from '../../../whatsapp-templates.service';

@Component({
  selector: 'app-whatsapp-template-media-header',
  templateUrl: './whatsapp-template-media-header.component.html',
  styleUrls: ['./whatsapp-template-media-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WhatsappTemplateMediaHeaderComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  AttachmentMediaTypeEnum = AttachmentMediaTypeEnum;
  supportedMediaTypes = '';
  file: {
    fileHandle: string;
    media_url: string;
    media_type: AttachmentMediaTypeEnum;
    filename: string;
    type: 'media';
  } = {} as any;
  selectMediaType: AttachmentMediaTypeEnum;

  uploadVideoMediaLabel = this.basicService.translate(
    'parameters/quick_replies/details/graph/whatsapp_message_with_buttons/edit_box_header_add_video'
  );
  uploadImageMediaLabel = this.basicService.translate(
    'parameters/quick_replies/details/graph/whatsapp_message_with_buttons/edit_box_header_add_image'
  );
  uploadDocumentMediaLabel = this.basicService.translate(
    'parameters/quick_replies/details/graph/whatsapp_message_with_buttons/edit_box_header_download_file'
  );

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  private subscriptions: Subscription = new Subscription();
  private siteId!: number;

  constructor(
    @Inject('AlertingFactory') private alertingService: any,
    private basicService: BasicService,
    private whatsappTemplatesService: WhatsappTemplatesService
  ) {}

  ngOnInit() {
    const { media_type, file_handle, media_url, filename } = this.form.value;
    if (media_type) {
      this.file.type = 'media';
      this.file.media_type = media_type;
      this.file.fileHandle = file_handle;
      this.file.media_url = media_url;
      this.file.filename = filename;
    }

    this.subscriptions.add(
      this.whatsappTemplatesService.createTemplateSiteIdUpdatedBS.subscribe(siteId => {
        if (siteId) {
          if (!this.file?.type) {
            this.file = {} as any;
          }
          this.siteId = siteId;
        }
      })
    );
  }

  selectMedia(mediaType: AttachmentMediaTypeEnum) {
    if (!this.siteId) {
      this.alertingService.info('parameters/whatsapp-templates/content/header/missing-account');
      return;
    }
    switch (mediaType) {
      case AttachmentMediaTypeEnum.Image:
        this.supportedMediaTypes = 'image/jpeg,image/png';
        break;
      case AttachmentMediaTypeEnum.Document:
        this.supportedMediaTypes = 'application/pdf';
        break;
      case AttachmentMediaTypeEnum.Video:
        this.supportedMediaTypes = 'video/mp4,video/3gpp';
        break;
      default:
        break;
    }
    this.selectMediaType = mediaType;
    setTimeout(() => this.fileInput.nativeElement.click(), 100);
  }

  uploadMedia($event) {
    const file = $event.target.files[0];
    if (file) {
      this.whatsappTemplatesService
        .uploadMediaForTemplate(this.siteId, file, this.selectMediaType)
        .subscribe(({ fileHandle, staticMediaId, staticMediaUrl }) => {
          const media_url = staticMediaUrl;
          this.form.get('media_type').setValue(this.selectMediaType);
          this.form.get('type').setValue('media');
          this.form.get('text').setValue(null);
          this.form.get('file_handle').setValue(fileHandle);
          this.form.get('media_id').setValue(staticMediaId);
          this.form.get('media_url').setValue(media_url);
          this.form.get('filename').setValue(file.name);
          this.form.get('static').setValue(this.form.value.static || null);
          this.file = {
            type: 'media',
            fileHandle,
            media_url,
            media_type: this.selectMediaType,
            filename: file.name,
          };
          this.form.markAsDirty();
          this.whatsappTemplatesService.headerMediaFileBS.next({
            fileHandle,
            media_url,
            file,
            mediaType: this.selectMediaType,
          });
        });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
